import AddResponseTag from './AddResponseTag';

const responseTag = {
  id: 'response',
  AddTag: AddResponseTag
};

export default responseTag;
